"use client";

import { SeoBlock } from "@/components/sections/sameday-delivery/SamedaySeoBlocksSection";
import SeoOnly from "@/components/seo/SeoOnly";

type Props = {
  ariaLabel?: string;
  body?: string;
};

const DEFAULT_BODY =
  "Dank runs licensed cannabis stores across Calgary and the surrounding area, each stocked with flower, pre-rolls, concentrates, edibles, beverages, vapes, and accessories. Our team helps you compare strains, formats, and potency so you can shop with confidence, new to cannabis or just refining your favourites. Planning a visit? Check hours and directions for your nearest Dank store, browse our online menu for live inventory, and ask our staff about current promos, bundle deals, and product education.";

export default function DispensarySeoSection({
  ariaLabel = "Calgary dispensary information",
  body = DEFAULT_BODY,
}: Props) {
  return (
    <SeoOnly>
      <section className="w-full max-w-none" aria-label={ariaLabel}>
      <div className="flex w-full flex-col gap-6">
        <SeoBlock title="SEO Section">
          {body}
        </SeoBlock>
      </div>
    </section>
    </SeoOnly>
  );
}
